import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.ProfileSettingWhatElseCollectProfile,
  {
    key: LocationVarKey.ProfileSettingWhatElseMessage,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWhatElseCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWhatElseCollectionMethod,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWhatElseCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWhatElseContactMethod,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWhatElseCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWhatElseWantShortProfile,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWhatElseCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWhatElseWantSecondaryOptional,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWhatElseWantShortProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWhatElseWantConfirmProfile,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWhatElseCollectProfile, "1")
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader
        {...page}
        subheading="Once a user's first question is answered, collect their contact information before asking what else we can help them with."
      >
        What Else
      </PageHeader>
      <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWhatElseCollectProfile} label="Collect Profile" />
      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingWhatElseCollectProfile, "1")}>
        <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ProfileSettingWhatElseMessage} />
        <DropdownRow
          {...page}
          marginTop
          label=" Collection Method"
          keyName={LocationVarKey.ProfileSettingWhatElseCollectionMethod}
          options={[
            {
              label: "Conversational",
              value: "Conversational"
            },
            {
              label: "Info Collect Card",
              value: "Card"
            }
          ]}
        />
        <DropdownRow
          {...page}
          marginTop
          label=" Preferred Contact Method"
          keyName={LocationVarKey.ProfileSettingWhatElseContactMethod}
          options={[
            {
              label: "Phone Number",
              value: "Phone"
            },
            {
              label: "Email",
              value: "Email"
            }
          ]}
        />
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWhatElseWantShortProfile} label="Short Profile" />
        <Indent {...page}>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.ProfileSettingWhatElseWantSecondaryOptional}
            hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingWhatElseWantShortProfile, "1")}
            label="Make Secondary Contact Method Optional"
          />
        </Indent>
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWhatElseWantConfirmProfile} label="Confirm Profile" />
      </Section>
    </>
  );
}
